export const itemListStyle = {
  border: '1px solid rgba(227,227,227)',
  borderRadius: '8px',
  width: '70vh',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 12px 12px 12px',
  boxShadow: '0 2px 8px rgb(0 0 0 / 10%)',
  cursor: 'pointer'
};
